import { useVideoAvailability } from '@statsbomb/video-client-js';
import { VideoReference } from '@statsbomb/video-client-js/dist/src/types';

/**
 * At the moment, the useVideoAvailability hook has a bug that means that, although it will accept an empty array, it
 * will error if you pass it one. This wrapper hook converts empty arrays to 'undefined' to work around this.
 * If/when the video team fix this bug, we can remove this wrapper and use the original.
 */
export const useParachuteVideoAvailability = <T extends Element>(videoReferences: VideoReference[]) =>
  useVideoAvailability<T>(videoReferences.length > 0 ? videoReferences : undefined);
